export const pricesToDisplay = (prices) => {
    const apartmentFallback = prices.apartment?.fallback;
    const houseFallback = prices.house?.fallback;
    if ((!apartmentFallback && !houseFallback) || (apartmentFallback && houseFallback)) {
        return [prices.apartment, prices.house];
    }
    return (apartmentFallback ? [prices.house] : [prices.apartment]);
};
